import { render, staticRenderFns } from "./DeleteSystemUserDialog.vue?vue&type=template&id=1b02c274&"
import script from "./DeleteSystemUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteSystemUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports